import { StyledFormField } from '@/components/styles'
import { useFormContext } from 'react-hook-form'
import { useState, useEffect, useRef } from 'react'
import { formErrors } from '@/lib/config'
import InputMask from 'react-input-mask'

const FormFieldMasked = props => {
  const { label, name, validateRules = {}, type = 'text', inputmode = '', autoFocus, mask } = props
  const { register, errors, triggerValidation } = useFormContext()

  const [focused, setFocused] = useState(false)
  const [errorVisible, setErrorVisible] = useState(false)
  const inputRef = useRef()

  const error = errors[name]
  const hasError = !!error
  const [inputValue, setInputValue] = useState('')
  const hasValue = !!inputValue.trim()

  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        inputRef.current.focus()
      }, 400)
    }
    return () => {
      setInputValue('')
    }
  }, [])

  const onInputChange = e => {
    const name = e.target.name
    const value = e.target.value
    setInputValue(value)
    triggerValidation(name)
  }

  return (
    <StyledFormField focused={focused} hasError={hasError} hasValue={hasValue}>
      <StyledFormField.Label>{label}</StyledFormField.Label>
      <InputMask
        mask={mask}
        name={name}
        value={inputValue}
        inputRef={e => {
          register(e, validateRules)
          inputRef.current = e
        }}
        onChange={onInputChange}
        hasValue={hasValue}
        error={errors[name]}
        onFocus={() => {
          setFocused(true)
        }}
        onBlur={() => {
          setFocused(false)
        }}
      >
        <Input type={type} inputMode={inputmode} />
      </InputMask>

      {hasError && (
        <StyledFormField.ErrorIcon
          onMouseEnter={() => {
            setErrorVisible(true)
          }}
          onMouseLeave={() => {
            setErrorVisible(false)
          }}
        />
      )}

      {hasError && (
        <StyledFormField.Error visible={errorVisible}>
          {formErrors[name] ? formErrors[name][error.type] : formErrors.default[error.type]}
        </StyledFormField.Error>
      )}
    </StyledFormField>
  )
}

const Input = React.memo(props => {
  const { name, inputRef, value, maskChar, ...inputProps } = props
  return <StyledFormField.Input value={value} name={name} ref={inputRef} {...inputProps} />
})

export default FormFieldMasked
